module.exports = __webpack_public_path__ + "media/luxury-2026/stanwich-facade-drone-960-9b8127f7.jpg";